import { Loader2 } from 'lucide-react';

export function DataSpinner() {
    return <Loader2 className="h-5 w-5 animate-spin inline-block text-primary" />;
}
